

























import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

export default Vue.extend({
  name: 'Taikai',
  data() {
    return {
      isSubmitting: false
    }
  },
  computed: {
    ...mapGetters('AppInfo', ['appName'])
  },
  methods: {
    ...mapActions('Auth', ['logout']),

    /**
     * 退会
     */
    async taikai() {
      const buttonIndex = await this.$_confirm('本当に退会しますか？', '', [
        'キャンセル',
        '退会する'
      ])
      if (this.$_clickedConfirmOK(buttonIndex)) {
        this.isSubmitting = true

        try {
          const res = await this.$http.post('/taikai/', {
            page: 'taikai',
            reason: ''
          })
          if (res.data.error) {
            this.isSubmitting = false
            this.$_alert(res.data.error)
            return
          }
          this.logout()
          // アプリなら端末内の情報を上書き削除
          if (this.$_hasCordova) {
            await this.$_secureSaveAccount({
              userId: '',
              password: ''
            })
          }
          this.$_resetStoreState()
          this.$router.replace('/signup')
          location.reload()
          this.isSubmitting = false
        } catch (err) {
          console.error(err)
          this.isSubmitting = false
        }
      }
    }
  }
})
